const isWithinZone = (hostname: string, zone: string): boolean =>
  hostname === zone || hostname.endsWith(`.${zone}`)

export function getSharedCookieDomain(hostname: string): string | undefined {
  if (isWithinZone(hostname, 'dev.signater.com')) return '.dev.signater.com'
  if (isWithinZone(hostname, 'signater.com')) return '.signater.com'
  return undefined
}
